<ng-container *transloco="let t">
    <div class="guidelines-dialog dialog-container sai-dialog-shell">
        <app-sai-dialog-header
            iconLigature="upload_file"
            [title]="t('Core Logic Upload Guidelines')"
            [subtitle]="t('Follow these rules to import Core Logic data successfully')"
            [showClose]="false"
        ></app-sai-dialog-header>

        <div class="content">
            <div class="guidelines-container">
                <div class="guideline-section critical">
                    <div class="section-header">
                        <mat-icon class="section-icon">table_chart</mat-icon>
                        <h2 class="section-title">
                            {{ t("Core Logic Columns") }}
                        </h2>
                        <span class="section-badge">{{
                            t("Required")
                        }}</span>
                    </div>
                    <div class="guidelines-grid">
                        <div class="guideline-card">
                            <div class="card-icon">
                                <mat-icon>format_list_numbered</mat-icon>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">{{ t("Level") }}</h3>
                                <p class="card-description">
                                    {{ t("KPI level/order, usually numeric") }}
                                </p>
                            </div>
                        </div>

                        <div class="guideline-card">
                            <div class="card-icon">
                                <mat-icon>label</mat-icon>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">
                                    {{ t("KPI Name") }}
                                </h3>
                                <p class="card-description">
                                    {{
                                        t(
                                            "Metric title shown in Core Logic table"
                                        )
                                    }}
                                </p>
                            </div>
                        </div>

                        <div class="guideline-card">
                            <div class="card-icon">
                                <mat-icon>functions</mat-icon>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">
                                    {{ t("Calculation") }}
                                </h3>
                                <p class="card-description">
                                    {{
                                        t(
                                            "Formula/expression used to compute KPI"
                                        )
                                    }}
                                </p>
                            </div>
                        </div>

                        <div class="guideline-card">
                            <div class="card-icon">
                                <mat-icon>notes</mat-icon>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">
                                    {{ t("Description") }}
                                </h3>
                                <p class="card-description">
                                    {{ t("Business meaning of the KPI") }}
                                </p>
                            </div>
                        </div>

                        <div class="guideline-card">
                            <div class="card-icon">
                                <mat-icon>lock</mat-icon>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">{{ t("Locked") }}</h3>
                                <p class="card-description">
                                    {{
                                        t(
                                            "Optional: Yes/No, True/False, 1/0"
                                        )
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="guideline-section technical">
                    <div class="section-header">
                        <mat-icon class="section-icon">info</mat-icon>
                        <h2 class="section-title">{{ t("Import Notes") }}</h2>
                        <span class="section-badge">{{ t("Important") }}</span>
                    </div>
                    <div class="guidelines-grid">
                        <div class="guideline-card">
                            <div class="card-icon">
                                <mat-icon>view_headline</mat-icon>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">
                                    {{ t("Header Row") }}
                                </h3>
                                <p class="card-description">
                                    {{
                                        t(
                                            "First row must contain column headers."
                                        )
                                    }}
                                </p>
                            </div>
                        </div>

                        <div class="guideline-card">
                            <div class="card-icon">
                                <mat-icon>spellcheck</mat-icon>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">
                                    {{ t("Column Matching") }}
                                </h3>
                                <p class="card-description">
                                    {{
                                        t(
                                            "Headers are case-insensitive, but keep exact names for best matching."
                                        )
                                    }}
                                </p>
                            </div>
                        </div>

                        <div class="guideline-card">
                            <div class="card-icon">
                                <mat-icon>filter_alt_off</mat-icon>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">
                                    {{ t("Empty Rows") }}
                                </h3>
                                <p class="card-description">
                                    {{
                                        t(
                                            "Blank rows are ignored; provide at least one valid KPI row."
                                        )
                                    }}
                                </p>
                            </div>
                        </div>

                        <div class="guideline-card">
                            <div class="card-icon">
                                <mat-icon>description</mat-icon>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">{{ t("Format") }}</h3>
                                <p class="card-description">
                                    {{ t("Supported file types: CSV, XLSX, XLS") }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="buttons">
            <div class="button-group">
                <button
                    type="button"
                    class="cancel-btn"
                    mat-flat-button
                    (click)="cancel()"
                >
                    <mat-icon>close</mat-icon>
                    <span>{{ t("Cancel") }}</span>
                </button>
                <button
                    type="button"
                    class="cancel-btn"
                    mat-flat-button
                    (click)="downloadTemplate()"
                >
                    <mat-icon>download</mat-icon>
                    <span>{{ t("Download Template") }}</span>
                </button>
                <button
                    type="button"
                    class="confirm-btn bg-primary"
                    mat-flat-button
                    (click)="uploadFile()"
                >
                    <mat-icon>upload_file</mat-icon>
                    <span>{{ t("Upload File") }}</span>
                </button>
            </div>
        </div>
    </div>
</ng-container>
